"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ValidationErrorId = exports.ValidationError = exports.LabelId = exports.Label = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _preactCompat = require("preact-compat");

var _Warning = _interopRequireDefault(require("@insided/shared/icons/Warning"));

var _idGenerator = _interopRequireDefault(require("../../utils/idGenerator"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var defaultLabelId;
var defaultIds;
var LabelId = (0, _preactCompat.createContext)(defaultLabelId);
exports.LabelId = LabelId;
var ValidationErrorId = (0, _preactCompat.createContext)(defaultIds);
exports.ValidationErrorId = ValidationErrorId;

var Label = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(Label, _PureComponent);

  var _super = _createSuper(Label);

  function Label() {
    (0, _classCallCheck2.default)(this, Label);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Label, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          isControl = _this$props.isControl;
      return (0, _preact.h)(LabelId.Consumer, null, function (id) {
        return (0, _preact.h)("label", {
          htmlFor: id,
          className: "a-label a-label--app-".concat(isControl ? 'control' : 'destination')
        }, children);
      });
    }
  }]);
  return Label;
}(_preactCompat.PureComponent);

exports.Label = Label;

var ValidationError = /*#__PURE__*/function (_PureComponent2) {
  (0, _inherits2.default)(ValidationError, _PureComponent2);

  var _super2 = _createSuper(ValidationError);

  function ValidationError() {
    (0, _classCallCheck2.default)(this, ValidationError);
    return _super2.apply(this, arguments);
  }

  (0, _createClass2.default)(ValidationError, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          isControl = _this$props2.isControl;
      return (0, _preact.h)(ValidationErrorId.Consumer, null, function (id) {
        return (0, _preact.h)("div", {
          className: "a-validation-error a-validation-error--app-".concat(isControl ? 'control' : 'destination')
        }, (0, _preact.h)(_Warning.default, {
          className: "a-validation-error__icon"
        }), (0, _preact.h)("span", {
          id: id,
          className: "a-validation-error__message"
        }, children));
      });
    }
  }]);
  return ValidationError;
}(_preactCompat.PureComponent);

exports.ValidationError = ValidationError;

var InputUnit = /*#__PURE__*/function (_PureComponent3) {
  (0, _inherits2.default)(InputUnit, _PureComponent3);

  var _super3 = _createSuper(InputUnit);

  function InputUnit() {
    (0, _classCallCheck2.default)(this, InputUnit);
    return _super3.apply(this, arguments);
  }

  (0, _createClass2.default)(InputUnit, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          error = _this$props3.error,
          isControl = _this$props3.isControl,
          label = _this$props3.label;
      return (0, _preact.h)(LabelId.Provider, {
        value: label ? (0, _idGenerator.default)(String(label)) : undefined
      }, (0, _preact.h)(ValidationErrorId.Provider, {
        value: error ? (0, _idGenerator.default)('validation-error') : null
      }, (0, _preact.h)("div", {
        className: "m-input-unit"
      }, label && (0, _preact.h)(Label, {
        isControl: isControl
      }, label), children, error && (0, _preact.h)(ValidationError, {
        isControl: isControl
      }, error))));
    }
  }]);
  return InputUnit;
}(_preactCompat.PureComponent);

var _default = InputUnit;
exports.default = _default;